import { render, staticRenderFns } from "./responsibleCardDialog.vue?vue&type=template&id=e65ef8bc"
import script from "./responsibleCardDialog.vue?vue&type=script&lang=ts"
export * from "./responsibleCardDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports